"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormEditState = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var input_state_group_1 = require("../components/input/input.state.group");
var form_edit_model_1 = require("../store/form.edit.model");
var mobx_2 = require("./mobx");
var FormEditState = /** @class */ (function (_super) {
    tslib_1.__extends(FormEditState, _super);
    function FormEditState(form) {
        var _this = _super.call(this) || this;
        _this.inputStates = new input_state_group_1.IkeInputStateGroup();
        _this.formRevision = form.revision;
        _this.editState = new form_edit_model_1.FormModelEditState(form);
        _this.form = new core_shared_1.FormModelEdit(form, _this.editState);
        return _this;
    }
    FormEditState.prototype.reset = function () {
        this.editState.reset();
    };
    FormEditState.prototype.revert = function (fieldId) {
        this.editState.fields.delete(fieldId);
    };
    FormEditState.prototype.discard = function () {
        if (this.editState != null) {
            this.editState.reset();
        }
    };
    FormEditState.prototype.isFieldDirty = function (fieldId) {
        return this.editState.fields.has(fieldId);
    };
    Object.defineProperty(FormEditState.prototype, "isDirty", {
        get: function () {
            return this.editState.isDirty;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormEditState.prototype, "isValid", {
        get: function () {
            return this.inputStates.isValid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormEditState.prototype, "canSubmit", {
        get: function () {
            return this.inputStates.canSubmit;
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.action
    ], FormEditState.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormEditState.prototype, "revert", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormEditState.prototype, "discard", null);
    return FormEditState;
}(mobx_2.MobxState));
exports.FormEditState = FormEditState;
//# sourceMappingURL=form.edit.state.js.map